<template>
  <!--
    Footerコンポーネント

    ブランド表示、基本機能へのアクセス（個人設定など）などを提供します。

    フッターに配置されるコンポーネントなので、このコンポーネント自体はfooterタグを使いません。
    footerタグを使うかどうかはこのフッターコンポーネントの利用側が決めます。
  -->
  <div class="footer" :class="containerClasses">
    <div class="actions footer-component">
      <div class="action" gl-tooltip="お知らせ" gl-tooltip-direction="down">
        <gl-button fab plain raised @click="moveToAnnoucement">
          <gl-icon-announcement style="color:#FFAB00" />
        </gl-button>
      </div>
      <div
        v-if="idPosSelected"
        class="action"
        :gl-tooltip="
          `顧客PFV参照${idPosEnabled ? '' : '（要ID-POSサービス契約）'}`
        "
        gl-tooltip-direction="down"
      >
        <gl-button
          fab
          plain
          raised
          @click="moveTo('pfv')"
          :disabled="!idPosEnabled"
        >
          <gl-icon-user style="color:#448aff" />
        </gl-button>
      </div>
      <div class="action" gl-tooltip="分析履歴" gl-tooltip-direction="down">
        <gl-button
          fab
          plain
          raised
          :badge="badgeStatus"
          :badge-variant="badgeVariant"
          :tooltip-text="badgeTooltip"
          @click="moveTo('query-management')"
        >
          <gl-icon-history style="color:#448aff" />
        </gl-button>
      </div>
      <div
        v-if="idPosSelected"
        class="action"
        :gl-tooltip="
          `ベン図でポン！${idPosEnabled ? '' : '（要ID-POSサービス契約）'}`
        "
        gl-tooltip-direction="down"
      >
        <gl-button
          fab
          plain
          raised
          @click="moveTo('pon')"
          :disabled="!idPosEnabled"
        >
          <gl-icon-venn-pon color="#448aff" />
        </gl-button>
      </div>
      <div
        v-if="
          ($store.getters.isAdmin || $store.getters.isHead) && idPosSelected
        "
        class="action"
        :gl-tooltip="
          `カードID相互変換${idPosEnabled ? '' : '（要ID-POSサービス契約）'}`
        "
        gl-tooltip-direction="down"
      >
        <gl-button
          fab
          plain
          raised
          @click="moveTo('card')"
          :disabled="!idPosEnabled"
        >
          <md-icon style="color:#448aff">credit_card</md-icon>
        </gl-button>
      </div>

      <div
        v-if="$store.getters.isAdmin"
        class="action"
        gl-tooltip="分析回数"
        gl-tooltip-direction="down"
      >
        <gl-button fab plain raised @click="moveTo('stats')">
          <md-icon style="color:#448aff">format_list_bulleted</md-icon>
        </gl-button>
      </div>
      <div
        v-if="
          ($store.getters.isAdmin || $store.getters.isHead) && idPosSelected
        "
        class="action"
        gl-tooltip="郵便番号集計"
        gl-tooltip-direction="down"
      >
        <gl-button fab plain raised @click="moveTo('zip')">
          <md-icon style="color:#448aff">map</md-icon>
        </gl-button>
      </div>
      <div class="action" gl-tooltip="おまとめ" gl-tooltip-direction="down">
        <gl-button fab plain raised @click="moveTo('omatome')">
          <md-icon style="color:#448aff">shopping_bag</md-icon>
        </gl-button>
      </div>
      <div
        v-if="isSettingAvailable"
        class="action"
        gl-tooltip="個人設定"
        gl-tooltip-direction="down"
      >
        <gl-button fab plain raised @click="moveTo('preferences')">
          <gl-icon-setting style="color:rgba(0,0,0,0.54)" />
        </gl-button>
      </div>
      <div
        v-if="
          ($store.getters.isAdmin || $store.getters.isHead) && idPosSelected
        "
        class="action"
        gl-tooltip="顧客属性アップロード"
        gl-tooltip-direction="down"
      >
        <gl-button
          fab
          plain
          raised
          @click="moveTo('user-customer-attribute-upload')"
        >
          <md-icon style="color:#448aff">upload_file</md-icon>
        </gl-button>
      </div>
    </div>

    <Divider></Divider>

    <div class="summaries footer-component">
      <gl-logo-bizoope />
      <gl-logo-app :onDarkBackground="dark" />
    </div>
  </div>
</template>

<script>
import { fromEvent } from 'rxjs'
import { isEqual } from 'lodash'
import Divider from '@/components/common/Divider.vue'

export default {
  components: { Divider },
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 個人設定ボタンの標示非表示制御
      isSettingAvailable: false,
      hasTodayReservationAnalysis: false,
      hasActionRequiredReservation: false,
    }
  },
  computed: {
    containerClasses() {
      return {
        dark: this.dark,
      }
    },
    // ログイン中のアカウントがID-POSサービスが利用か否か
    // TODO stateで提供してもいいかも
    idPosEnabled() {
      return this.$store.state.account.services.includes('idpos')
    },
    idPosSelected() {
      return ['idpos', 'recent'].includes(this.$store.state.menuDataType)
    },
    posSelected() {
      return ['pos', 'recent'].includes(this.$store.state.menuDataType)
    },
    // 分析履歴ボタンのバッジ表示ロジック
    // 優先度: 処理が必要な予約（赤） > 本日実行分析（青）
    badgeStatus() {
      if (this.$store.getters.isDeveloper) {
        if (
          this.hasActionRequiredReservation ||
          this.hasTodayReservationAnalysis
        ) {
          return true
        }
      }
      return false
    },
    badgeVariant() {
      // 処理が必要な予約 → 赤（優先）
      if (this.$store.getters.isDeveloper) {
        if (this.hasActionRequiredReservation) {
          return 'warn'
        }
        // 本日実行分析 → 青
        if (this.hasTodayReservationAnalysis) {
          return 'primary'
        }
      }
      return 'primary'
    },
    badgeTooltip() {
      if (this.$store.getters.isDeveloper) {
        if (this.hasActionRequiredReservation) {
          return '予約設定の更新が必要です'
        }
        if (this.hasTodayReservationAnalysis) {
          return '実行された分析予約があります'
        }
      }
      return ''
    },
  },
  methods: {
    moveTo(url) {
      this.$router.push(`/${url}`)
    },
    moveToAnnoucement() {
      this.hasUnreadAnnouncements = false
      window.open(
        process.env.VUE_APP_BIZOO_ANNOUNCEMENT_URL
          ? process.env.VUE_APP_BIZOO_ANNOUNCEMENT_URL
          : 'https://www.cyber-l.co.jp/',
      )
    },
    async fetchBadgeStatus() {
      try {
        var ret = await this.$repositories
          .get('queryReservation')
          .getReservationExecutionStatus()
        this.hasTodayReservationAnalysis = ret
      } catch (e) {
        this.hasTodayReservationAnalysis = false
      }

      // 処理が必要な予約の状態を取得
      try {
        var hasActionRequired = await this.$repositories
          .get('queryReservation')
          .hasActionRequiredReservation()
        this.hasActionRequiredReservation = hasActionRequired
      } catch (e) {
        this.hasActionRequiredReservation = false
      }
    },
  },
  mounted() {
    // 遊びなので消しても大丈夫です。
    const subscription = fromEvent(document, 'keydown').subscribe(e => {
      if (keyInputs.length >= COMMAND.length) {
        keyInputs.shift()
      }
      keyInputs.push(e.key)
      if (isEqual(keyInputs, COMMAND)) {
        this.isSettingAvailable = true
      }
    })
    this.$on('hook:beforeDestroy', () => subscription.unsubscribe())

    // 近日実行された予約分析があるかを取得
    this.fetchBadgeStatus()
  },
}

const COMMAND = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'b',
  'a',
]
const keyInputs = []
</script>

<style lang="scss" scoped>
.footer {
  font-size: var(--font-size-small);
  width: 100%;

  &.dark {
    background-color: var(--bg-color-accent);
    color: #fff;
  }

  .footer-component {
    padding: var(--spacing-medium-large);
    text-align: center;
  }

  .actions {
    display: flex;
    justify-content: center;
  }

  .action {
    margin-left: var(--spacing-small);

    &:first-child {
      margin-left: 0;
    }
  }
}
.summaries {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: var(--spacing-medium-large);
}
</style>
